import { Suspense, lazy } from "react";
import { RouteObject } from "react-router";
import { Navigate } from "react-router-dom";
import SuspenseLoader from "src/components/SuspenseLoader";
import SidebarLayout from "src/layouts/SidebarLayout";
import PrivateRoute from "./Reducers/AuthReducer/PrivateRoute";
import AccountList from "./content/modules/Accounts/AccountList";
import SingleAccountPage from "./content/modules/Accounts/SingleAccountPage";
import AdminList from "./content/modules/Admin/AdminList";
import AuditTrail from "./content/modules/Admin/AuditTrail";
import CreateAdmin from "./content/modules/Admin/CreateAdmin";
import SingleAdmin from "./content/modules/Admin/singleAdmin/SingleAdmin";
import B2BList from "./content/modules/B2B/allB2BList/AllB2Blist";
import B2BInvoice from "./content/modules/B2B/b2binvoice/B2BInvoice";
import CreateB2BInvoice from "./content/modules/B2B/b2binvoice/CreateB2BInvoice";
import B2BSingleInvoice from "./content/modules/B2B/b2binvoice/singleB2BInvoice/B2BSingleInvoice";
import B2BMoneyReceiptList from "./content/modules/B2B/moneyReceipt/B2BMoneyReceiptList";
import ViewB2BMoneyReceipt from "./content/modules/B2B/moneyReceipt/ViewB2BMoneyReceipt";
import SingleB2B from "./content/modules/B2B/singleB2B/SingleB2B";
import B2BSessionList from "./content/modules/B2BSession/B2BSessionList";
import SessionEnrollList from "./content/modules/B2BSession/SessionEnroll/SessionEnrollList";
import SessionRequestList from "./content/modules/B2BSession/SessionRequest/SessionRequestList";
import ChatbotKnowledgeBase from "./content/modules/ChatbotKnowledgeBase/ChatbotKnowledgeBase";
import EntryFairList from "./content/modules/EntryFair/EntryFair";
import AdminFair from "./content/modules/Fair/AdminFair";
import SingleFairApplicationPage from "./content/modules/Fair/SingleFair/Index";
import AllEventList from "./content/modules/FairEvent/AllEventList/AllEventList";
import CreateEvent from "./content/modules/FairEvent/CreateEvent/CreateEvent";
import SingleEvent from "./content/modules/FairEvent/SingleEvent/SingleEvent";
import FairStallList from "./content/modules/FairStall/FairStallList";
import SingleStallPage from "./content/modules/FairStall/SingleStallPage";
import FeedbackList from "./content/modules/Feedback/FeedbackList";
import AllGuestList from "./content/modules/GuestAndSpecker/AllGuestAndSpeaker";
import SingleGuestAndSpeaker from "./content/modules/GuestAndSpecker/SingleGuestAndSpeaker";
import CreateMeeting from "./content/modules/Members/Meeting/CreateMeeting";
import Meeting from "./content/modules/Members/Meeting/Index";
import SingleMeetingPage from "./content/modules/Members/Meeting/singleMeeting/Index";
import InvoiceList from "./content/modules/Members/subModules/invoice/allInvoice/InvoiceList";
import CreateInvoice from "./content/modules/Members/subModules/invoice/createInvoice";
import MemberList from "./content/modules/Members/subModules/memberList/allMember/MemberList";
import CompanyInfoDetails from "./content/modules/Members/subModules/memberList/singleMember";
import CompanyInvoices from "./content/modules/Members/subModules/memberList/singleMember/CompanyInfoDetailsComponents/CompanyInvoices";
import PayableItemList from "./content/modules/PaymentableItem/AllPaymentableItem/PaymentableItemList";
import PaymentItemConfig from "./content/modules/PaymentableItem/PaymentItemConfig/PaymentItemConfig";
import CategoryList from "./content/modules/ProductCategory/CategoryList";
import {
	ParticipantList,
	PrizeList,
	WinnerList,
} from "./content/modules/RaffleDraw";
import AccountReport from "./content/modules/Reports/AccountReport";
import B2BLedger from "./content/modules/Reports/B2BLedger";
import CollectionReport from "./content/modules/Reports/CollectionReport";
import ExhibitorLedger from "./content/modules/Reports/ExhibitorLedger";
import VisitorLedger from "./content/modules/Reports/VisitorLedger";
import Trainee from "./content/modules/Training/subModules/trainee/allTrainee/Index";
import SingleTrainee from "./content/modules/Training/subModules/trainee/singleTrainee/Index";
import RecentOrders from "./content/modules/Transactions/RecentOrders";
import ConferenceList from "./content/modules/conference/ConferenceList";
import ExhibitorList from "./content/modules/exhibitor/ExhibitorList";
import MoneyReceipt from "./content/modules/exhibitor/MoneyReceipt/MoneyReceipt";
import SingleMoneyReceipt from "./content/modules/exhibitor/MoneyReceipt/SingleMoneyReceipt";
import SingleOfflineExhibitorPage from "./content/modules/exhibitor/NewExhibitorList/SingleOfflineExhibitorPage";
import ProductPage from "./content/modules/exhibitor/Products/ProductPage";
import ExhibitorSingleProduct from "./content/modules/exhibitor/SingleExhibitorDetails/SingleProductByExhibitor";
import CreateExhibitorInvoice from "./content/modules/exhibitor/exhibitorInvoice/CreateExhibitorInvoice";
import ExhibitorInvoice from "./content/modules/exhibitor/exhibitorInvoice/ExhibitorInvoice";
import ExhibitorSingleInvoice from "./content/modules/exhibitor/exhibitorInvoice/singleInvoice/ExhibitorSingleInvoice";
import SMS from "./content/modules/sms";
import CreateTicketPage from "./content/modules/visitor/CreateTicket/CreateTicketPage";
import ViewVisitorMoneyReceipt from "./content/modules/visitor/MoneyReceipt/ViewVisitorMoneyReceipt";
import MoneyReceiptList from "./content/modules/visitor/MoneyReceipt/VisitorMoneyReceiptList";
import SingleVisitorPage from "./content/modules/visitor/NewVisitorList/SingleVisitorPage";
import TicketConfiguration from "./content/modules/visitor/TicketConfiguration/TicketConfiguration";
import GiftManagementPage from "./content/modules/visitor/GiftManagement";
import ScanHistoryPage from "./content/modules/visitor/TicketScan/ScanHistoryPage";
import ScanTicketPage from "./content/modules/visitor/TicketScan/ScanTicketPage";
import SingleTicketPage from "./content/modules/visitor/TicketScan/SingleTicketPage";
import TicketListPage from "./content/modules/visitor/TicketScan/TicketListPage";
import VisitorList from "./content/modules/visitor/allVisitorList/AllVisitorList";
import CreateVisitorInvoice from "./content/modules/visitor/visitorInvoice/CreateVisitorInvoice";
import SingleVisitorInvoicePage from "./content/modules/visitor/visitorInvoice/SingleVisitor/SingleVisitor";
import VisitorInvoiceList from "./content/modules/visitor/visitorInvoice/VisitorInvoiceList";
import WhatsonList from "./content/modules/whatson/WhatsonList";
import ForgetPassword from "./content/pages/Forget/ForgetPassword";
import ChangePassword from "./content/pages/changePassword/ChangePassword";
import OtpSend from "./content/pages/otp/OtpSend";


const Loader = (Component) => (props) =>
(
	<Suspense fallback={<SuspenseLoader />}>
		<Component {...props} />
	</Suspense>
);

// Pages
const SingleInvoicePage = Loader(
	lazy(
		() =>
			import(
				"./content/modules/Members/subModules/invoice/singleInvoice/SingleInvoicePage"
			)
	)
);

// login
const Login = Loader(lazy(() => import("./content/pages/Login/Login")));

// Dashboards
const DashboardOverview = Loader(
	lazy(() => import("src/content/modules/dashboard"))
);

// Applications
const Messenger = Loader(lazy(() => import("src/content/modules/Messenger")));
const Transactions = Loader(
	lazy(() => import("src/content/modules/Transactions"))
);
const UserProfile = Loader(
	lazy(() => import("src/content/modules/Users/profile"))
);
const UserSettings = Loader(
	lazy(() => import("src/content/modules/Users/settings"))
);

// Status
const Status404 = Loader(
	lazy(() => import("src/content/pages/Status/Status404"))
);
const Status500 = Loader(
	lazy(() => import("src/content/pages/Status/Status500"))
);
const StatusComingSoon = Loader(
	lazy(() => import("src/content/pages/Status/ComingSoon"))
);
const StatusMaintenance = Loader(
	lazy(() => import("src/content/pages/Status/Maintenance"))
);

const routes: RouteObject[] = [
	{
		path: "/",
		element: <PrivateRoute component={<SidebarLayout />} />,
		children: [
			{
				path: "/",
				element: <Navigate to="dashboard" replace />,
			},
			{
				path: "dashboard",
				element: <DashboardOverview />,
			},

			{
				path: "status",
				children: [
					{
						path: "/status",
						element: <Navigate to="404" replace />,
					},
					{
						path: "404",
						element: <Status404 />,
					},
					{
						path: "500",
						element: <Status500 />,
					},
					{
						path: "maintenance",
						element: <StatusMaintenance />,
					},
					{
						path: "coming-soon",
						element: <StatusComingSoon />,
					},
				],
			},
		],
	},
	{
		path: "support",
		element: <PrivateRoute component={<SidebarLayout />} />,
		children: [
			{
				path: "/support",
				element: <Navigate to="conversations" replace />,
			},
			{
				path: "conversations",
				element: <Messenger />,
			},
		],
	},
	{
		path: "invoices",
		element: <PrivateRoute component={<SidebarLayout />} />,
		children: [
			{
				path: "/invoices",
				element: <Navigate to="transactions" replace />,
			},
			{
				path: "transactions",
				element: <InvoiceList />,
			},
			{
				path: "transactions/:id",
				element: <SingleInvoicePage />,
			},
			{
				path: "create-invoice",
				element: <CreateInvoice />,
			},
		],
	},
	{
		path: "create-admin",
		element: <SidebarLayout />,
		children: [
			{
				path: "/create-admin",
				element: <CreateAdmin />,
			},
		],
	},
	{
		path: "audit-trail",
		element: <SidebarLayout />,
		children: [
			{
				path: "/audit-trail",
				element: <AuditTrail />,
			},
		],
	},
	{
		path: "recent",
		element: <SidebarLayout />,
		children: [
			{
				path: "/recent",
				element: <RecentOrders />,
			},
		],
	},

	{
		path: "service-item",
		element: <PrivateRoute component={<SidebarLayout />} />,
		children: [
			{
				path: "/service-item",
				element: <Navigate to="list" replace />,
			},
			{
				path: "list",
				element: <PayableItemList />,
			},
			{
				path: "config",
				element: <PaymentItemConfig />,
			},
			{
				path: "payment-config",
				element: <PaymentItemConfig />,
			},
		],
	},
	{
		path: "payment-item-config",
		element: <PrivateRoute component={<SidebarLayout />} />,
		children: [
			{
				path: "",
				element: <PaymentItemConfig />,
			},
		],
	},

	{
		path: "product-categories",
		element: <PrivateRoute component={<SidebarLayout />} />,
		children: [
			{
				path: "/product-categories",
				element: <Navigate to="list" replace />,
			},
			{
				path: "list",
				element: <CategoryList />,
			},
		],
	},

	{
		path: "chatbot",
		element: <PrivateRoute component={<SidebarLayout />} />,
		children: [
			{
				path: "",
				element: <Navigate to="knowledge-base" replace />,
			},
			{
				path: "knowledge-base",
				element: <ChatbotKnowledgeBase />,
			},
		],
	},

	{
		path: "chatbot-knowledge-base",
		element: <PrivateRoute component={<SidebarLayout />} />,
		children: [
			{
				path: "",
				element: <ChatbotKnowledgeBase />,
			},
		],
	},

	{
		path: "configurations",
		element: <PrivateRoute component={<SidebarLayout />} />,
		children: [
			{
				path: "chatbot-knowledge-base",
				element: <ChatbotKnowledgeBase />,
			},
		],
	},

	{
		path: "member-list",
		element: <PrivateRoute component={<SidebarLayout />} />,
		children: [
			{
				path: "/member-list",
				element: <MemberList />,
			},
			{
				path: ":memberId/invoice",
				element: <CompanyInvoices />,
			},
			{
				path: ":memberId",
				element: <CompanyInfoDetails />,
			},
			{
				path: "meeting",
				element: <Meeting />,
			},
			{
				path: "meeting/:meetingId",
				element: <SingleMeetingPage />,
			},
			{
				path: "create-meeting",
				element: <CreateMeeting />,
			},
		],
	},
	{
		path: "courses",
		element: <PrivateRoute component={<SidebarLayout />} />,
		children: [
			{
				path: "/courses",
				element: <Navigate to="batch" replace />,
			},
			{
				path: "batch",
				element: <Trainee />,
			},
			{
				path: "trainee",
				element: <Trainee />,
			},
			{
				path: "trainee/:traineeId",
				element: <SingleTrainee />,
			},
		],
	},

	// This is entry fair module routing file
	{
		path: "entry-fair",
		element: <PrivateRoute component={<SidebarLayout />} />,
		children: [
			{
				path: "/entry-fair",
				element: <Navigate to="list" replace />,
			},
			{
				path: "list",
				element: <EntryFairList />,
			},
		],
	},
	// This is fair module routing file
	{
		path: "fair",
		element: <PrivateRoute component={<SidebarLayout />} />,
		children: [
			{
				path: "/fair",
				element: <Navigate to="list" replace />,
			},
			{
				path: "list",
				element: <AdminFair />,
			},
			{
				path: "list/:singleFairId",
				element: <SingleFairApplicationPage />,
			},
			{
				path: "stall-list",
				element: <FairStallList />,
			},
			{
				path: "stall/:id",
				element: <SingleStallPage />,
			},
			{
				path: "feedback",
				element: <FeedbackList />,
			},
			{
				path: "feedback-list",
				element: <FeedbackList />,
			},
		],
	},
	{
		path: "feedback",
		element: <PrivateRoute component={<SidebarLayout />} />,
		children: [
			{
				path: "",
				element: <FeedbackList />,
			},
		],
	},
	{
		path: "conference&whatson",
		element: <PrivateRoute component={<SidebarLayout />} />,
		children: [
			{
				path: "conference",
				element: <Navigate to="conference_list" replace />,
			},
			{
				path: "conference_list",
				element: <ConferenceList />,
			},
			{
				path: "whatson",
				element: <Navigate to="whatson_list" replace />,
			},
			{
				path: "whatson_list",
				element: <WhatsonList />,
			},
			{
				path: "list/:singleFairId",
				element: <SingleFairApplicationPage />,
			},
			{
				path: "stall-list",
				element: <FairStallList />,
			},
			{
				path: "stall/:id",
				element: <SingleStallPage />,
			},
			// Optional future routes
			// {
			//   path: "stall-application",
			//   element: <StallApplication />,
			// },
			// {
			//   path: "stall-application/:stallApplicationId",
			//   element: <SingleStallApplication />,
			// },
		],
	},
	{
		path: "guest-speaker",
		element: <PrivateRoute component={<SidebarLayout />} />,
		children: [
			{
				path: "/guest-speaker",
				element: <Navigate to="list" replace />,
			},
			{
				path: "guest-list",
				element: <AllGuestList />,
			},
			{
				path: "guest-list/details/:id",
				element: <SingleGuestAndSpeaker />,
			},
		],
	},
	{
		path: "exhibitor",
		element: <PrivateRoute component={<SidebarLayout />} />,
		children: [
			{
				path: "/exhibitor",
				element: <Navigate to="list" replace />,
			},
			{
				path: "list",
				element: <ExhibitorList />,
			},
			{
				path: "money-receipt/list",
				element: <MoneyReceipt />,
			},
			{
				path: "products",
				element: <ProductPage />,
			},
			{
				path: "money-receipt/details/:id",
				element: <SingleMoneyReceipt />,
			},
			{
				path: "details/:id",
				element: <SingleOfflineExhibitorPage />,
			},
			{
				path: "list/:singleMemberFairId",
				element: <SingleOfflineExhibitorPage />,
			},
			{
				path: "list/:singleMemberFairId/product/:ExhibitorSingleProduct",
				element: <ExhibitorSingleProduct />,
			},
			{
				path: "invoice-list",
				element: <ExhibitorInvoice />,
			},
			{
				path: "invoice-list/:singleExhibitorInvoiceId",
				element: <ExhibitorSingleInvoice />,
			},
			{
				path: "create-invoice",
				element: <CreateExhibitorInvoice />,
			},
		],
	},
	{
		path: "visitor",
		element: <PrivateRoute component={<SidebarLayout />} />,
		children: [
			{
				path: "/visitor",
				element: <Navigate to="list" replace />,
			},
			{
				path: "ticket-config",
				element: <TicketConfiguration />,
			},
			{
				path: "create-ticket",
				element: <CreateTicketPage />,
			},
			{
				path: "scan-ticket",
				element: <ScanTicketPage />,
			},
			{
				path: "ticket-scan",
				element: <ScanTicketPage />,
			},
			{
				path: "ticket-list",
				element: <TicketListPage />,
			},
			{
				path: "ticket-list/:id",
				element: <SingleTicketPage />,
			},
			{
				path: "ticket-list/details/:id",
				element: <SingleTicketPage />,
			},
			{
				path: "ticket/:id",
				element: <SingleTicketPage />,
			},
			{
				path: "scan-history",
				element: <ScanHistoryPage />,
			},
			{
				path: "gift-management",
				element: <GiftManagementPage />,
			},
			{
				path: "gift",
				element: <GiftManagementPage />,
			},
			{
				path: "gift-list",
				element: <GiftManagementPage />,
			},
			{
				path: "list",
				element: <VisitorList />,
			},
			{
				path: "details/:id",
				element: <SingleVisitorPage />,
			},
			{
				path: "list/:singleVisitorId",
				element: <SingleVisitorPage />,
			},
			{
				path: "visitor-invoice",
				element: <VisitorInvoiceList />,
			},
			{
				path: "visitor-invoice/:visitorInvoiceId",
				element: <SingleVisitorInvoicePage />,
			},
			{
				path: "money-receipt/details/:id",
				element: <ViewVisitorMoneyReceipt />,
			},
			{
				path: "create-invoice",
				element: <CreateVisitorInvoice />,
			},
			{
				path: "money-receipt",
				element: <MoneyReceiptList />,
			},
		],
	},

	{
		path: "b2b",
		element: <PrivateRoute component={<SidebarLayout />} />,
		children: [
			{
				path: "/b2b",
				element: <Navigate to="list" replace />,
			},
			{
				path: "list",
				element: <B2BList />,
			},
			{
				path: "list/:singleB2BId",
				element: <SingleB2B />,
			},
			{
				path: "b2b-invoice",
				element: <B2BInvoice />,
			},
			{
				path: "money-receipt",
				element: <B2BMoneyReceiptList />,
			},
			{
				path: "money-receipt/details/:id",
				element: <ViewB2BMoneyReceipt />,
			},
			{
				path: "b2b-invoice/:b2b_invoice_id",
				element: <B2BSingleInvoice />,
			},
			{
				path: "create-b2b-invoice",
				element: <CreateB2BInvoice />,
			},
		],
	},

	{
		path: "b2b-session",
		element: <PrivateRoute component={<SidebarLayout />} />,
		children: [
			{
				path: "/b2b-session",
				element: <Navigate to="list" replace />,
			},
			{
				path: "list",
				element: <B2BSessionList />,
			},
			{
				path: "requests",
				element: <SessionRequestList />,
			},
			{
				path: "request-list",
				element: <SessionRequestList />,
			},
			{
				path: "enroll",
				element: <SessionEnrollList />,
			},
			{
				path: "enrolls",
				element: <SessionEnrollList />,
			},
			{
				path: "enrollments",
				element: <SessionEnrollList />,
			},
		],
	},

	{
		path: "fair-event",
		element: <PrivateRoute component={<SidebarLayout />} />,
		children: [
			{
				path: "/fair-event",
				element: <Navigate to="list" replace />,
			},
			{
				path: "create-event",
				element: <CreateEvent />,
			},
			{
				path: "all-event-list",
				element: <AllEventList />,
			},
			{
				path: "all-event-list/:eventId",
				element: <SingleEvent />,
			},
		],
	},

	{
		path: "raffle-draw",
		element: <PrivateRoute component={<SidebarLayout />} />,
		children: [
			{
				path: "",
				element: <Navigate to="prize" replace />,
			},
			{
				path: "/raffle-draw",
				element: <Navigate to="prize" replace />,
			},
			{
				path: "prize",
				element: <PrizeList />,
			},
			{
				path: "participant",
				element: <ParticipantList />,
			},
			{
				path: "winner",
				element: <WinnerList />,
			},
		],
	},

	{
		path: "admin-list",
		element: <PrivateRoute component={<SidebarLayout />} />,
		children: [
			{
				path: "/admin-list",
				element: <AdminList />,
			},
			{
				path: "single-admin/:id",
				element: <SingleAdmin />,
			},
		],
	},
	{
		path: "sms",
		element: <PrivateRoute component={<SidebarLayout />} />,
		children: [
			{
				path: "/sms",
				element: <SMS />,
			},
		],
	},

	{
		path: "profile",
		element: <PrivateRoute component={<SidebarLayout />} />,
		children: [
			{
				path: "/profile",
				element: <Navigate to="details" replace />,
			},
			{
				path: "details",
				element: <UserProfile />,
			},
			{
				path: "settings",
				element: <UserSettings />,
			},
		],
	},

	{
		path: "accounts",
		element: <PrivateRoute component={<SidebarLayout />} />,
		children: [
			{
				path: "/accounts",
				element: <Navigate to="list" replace />,
			},
			{
				path: "balance-adjustment",
				element: <AccountList />,
			},
			{
				path: "balance-transfer",
				element: <AccountList />,
			},
			{
				path: "list",
				element: <AccountList />,
			},
			{
				path: "list/details/:id",
				element: <SingleAccountPage />,
			},
		],
	},
	{
		path: "report",
		element: <PrivateRoute component={<SidebarLayout />} />,
		children: [
			{
				path: "account-report",
				element: <Navigate to="list" replace />,
			},
			{
				path: "account-report/list",
				element: <AccountReport />,
			},
			{
				path: "exhibitor-report/list",
				element: <ExhibitorLedger />,
			},
			{
				path: "b2b/list",
				element: <B2BLedger />,
			},
			{
				path: "visitor/list",
				element: <VisitorLedger />,
			},
			{
				path: "collection/list",
				element: <CollectionReport />,
			},
		],
	},
	{
		path: "login",
		element: <Login />,
	},
	{
		path: "forget-password",
		element: <ForgetPassword />,
	},
	{
		path: "forget-password/otp",
		element: <OtpSend />,
	},
	{
		path: "change-password/*",
		element: <ChangePassword />,
	},

	{
		path: "*",
		element: <Status404 />,
	},
];

export default routes;
